webpackJsonp([1],{

/***/ 100:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pusher"
  }, [_c('div', {
    staticClass: "ui inverted vertical center aligned segment"
  }, [_c('div', {
    staticClass: "ui container"
  }, [_c('div', {
    staticClass: "ui large secondary inverted pointing menu"
  }, [_vm._m(0), _vm._v(" "), _c('router-link', {
    staticClass: "item",
    attrs: {
      "to": {
        name: 'Hello'
      }
    }
  }, [_vm._v("About")]), _vm._v(" "), _c('router-link', {
    staticClass: "item",
    attrs: {
      "to": {
        name: 'Pricing'
      }
    }
  }, [_vm._v("Pricing")]), _vm._v(" "), _c('div', {
    staticClass: "right item"
  }, [_c('router-link', {
    staticClass: "ui inverted button",
    attrs: {
      "to": {
        name: 'Login'
      }
    }
  }, [_vm._v("Log In")])], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "ui vertical aligned segment"
  }, [_c('div', {
    staticClass: "ui text container",
    attrs: {
      "id": "pricing-section"
    }
  }, [_c('h1', [_vm._v("Select plan")]), _vm._v(" "), _c('form', {
    staticClass: "ui form",
    attrs: {
      "id": "payment-form",
      "onsubmit": "return false"
    }
  }, [_c('p', [_vm._v("FIXME: " + _vm._s(_vm.plan))]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("Plan")]), _vm._v(" "), _c('div', {
    staticClass: "ui fluid selection dropdown",
    attrs: {
      "id": "plan-select"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plan),
      expression: "plan"
    }],
    attrs: {
      "type": "hidden",
      "name": "plan"
    },
    domProps: {
      "value": (_vm.plan)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.plan = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "dropdown icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "default text"
  }, [_vm._v("Select Plan")]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), (_vm.countyPlan) ? _c('label', [_vm._v("Select counties")]) : _vm._e(), _vm._v(" "), (_vm.countyPlan) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.counties),
      expression: "counties"
    }],
    staticClass: "ui fluid search dropdown",
    attrs: {
      "id": "county-select",
      "multiple": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.counties = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("State")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "AL"
    }
  }, [_vm._v("Alabama")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "AK"
    }
  }, [_vm._v("Alaska")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "AZ"
    }
  }, [_vm._v("Arizona")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "AR"
    }
  }, [_vm._v("Arkansas")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "CA"
    }
  }, [_vm._v("California")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "CO"
    }
  }, [_vm._v("Colorado")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "CT"
    }
  }, [_vm._v("Connecticut")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DE"
    }
  }, [_vm._v("Delaware")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DC"
    }
  }, [_vm._v("District Of Columbia")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "type": "text",
      "name": "email",
      "placeholder": "your-email@example.com"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "click": _vm.emailComplete,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    attrs: {
      "type": "text",
      "name": "name",
      "placeholder": "Joe Bloggs"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("Phone (optional)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    attrs: {
      "type": "text",
      "name": "phone",
      "placeholder": "123-456-7890"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password",
      "name": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "ui checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.terms),
      expression: "terms"
    }],
    attrs: {
      "type": "checkbox",
      "name": "terms"
    },
    domProps: {
      "checked": Array.isArray(_vm.terms) ? _vm._i(_vm.terms, null) > -1 : (_vm.terms)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.terms,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.terms = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.terms = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.terms = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("I agree to the Terms and Conditions")])])]), _vm._v(" "), (_vm.errorMessage) ? _c('div', {
    staticClass: "ui negative message"
  }, [_c('i', {
    staticClass: "close icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [_vm._v("\n            Oh no! There was an error during signup\n          ")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.errorMessage))])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "ui button primary approve",
    class: {
      'disabled': !_vm.filledIn || _vm.submitted
    },
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Submit")]), _vm._v(" "), _c('div', {
    staticClass: "ui error message"
  })])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "toc item"
  }, [_c('i', {
    staticClass: "sidebar icon"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu"
  }, [_c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "us-all"
    }
  }, [_c('i', {
    staticClass: "us flag"
  }), _vm._v("\n                All of the US ($2000)\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "county"
    }
  }, [_c('i', {
    staticClass: "add to cart icon"
  }), _vm._v("\n                Per county ($250)\n              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-row"
  }, [_c('label', {
    attrs: {
      "for": "card-element"
    }
  }, [_vm._v("\n            Credit or debit card\n          ")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "card-element"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "card-errors",
      "role": "alert"
    }
  })])
}]}

/***/ }),

/***/ 101:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pusher"
  }, [_c('div', {
    staticClass: "ui inverted vertical center aligned segment"
  }, [_c('div', {
    staticClass: "ui container"
  }, [_c('div', {
    staticClass: "ui large secondary inverted pointing menu"
  }, [_vm._m(0), _vm._v(" "), _c('router-link', {
    staticClass: "item",
    attrs: {
      "to": {
        name: 'Hello'
      }
    }
  }, [_vm._v("About")]), _vm._v(" "), _c('router-link', {
    staticClass: "item",
    attrs: {
      "to": {
        name: 'Pricing'
      }
    }
  }, [_vm._v("Pricing")]), _vm._v(" "), _c('div', {
    staticClass: "right item"
  }, [_c('router-link', {
    staticClass: "ui inverted button",
    attrs: {
      "to": {
        name: 'Signup'
      }
    }
  }, [_vm._v("Sign Up")])], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "ui container basic segment"
  }, [_c('div', {
    staticClass: "ui middle aligned center aligned grid"
  }, [_c('div', {
    staticClass: "column"
  }, [_vm._m(1), _vm._v(" "), _c('form', {
    staticClass: "ui large form",
    attrs: {
      "id": "login",
      "onsubmit": "return false"
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "ui left icon input"
  }, [_c('i', {
    staticClass: "user icon"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "type": "text",
      "name": "email",
      "placeholder": "your-email@example.com",
      "id": "email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "ui left icon input"
  }, [_c('i', {
    staticClass: "lock icon"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password",
      "name": "password",
      "placeholder": "Your password",
      "id": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.errorMessage) ? _c('div', {
    staticClass: "ui negative message"
  }, [_c('i', {
    staticClass: "close icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [_vm._v("\n              Oops! There was an error during login\n            ")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.errorMessage))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ui fluid large primary button",
    class: {
      'disabled': !_vm.filledIn
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("Login")]), _vm._v(" "), _c('div', {
    staticClass: "ui error message"
  }), _vm._v(" "), _c('div', {
    staticClass: "ui right aligned basic segment"
  }, [_c('div', {
    staticClass: "ui list"
  }, [_c('a', {
    staticClass: "item",
    on: {
      "click": _vm.forgotPasswordModal
    }
  }, [_vm._v("Forgot Password")]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_vm._v("New to us? Sign up "), _c('router-link', {
    attrs: {
      "to": {
        name: 'Signup'
      }
    }
  }, [_vm._v("here")]), _vm._v("!")], 1)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "ui modal"
  }, [_c('i', {
    staticClass: "close icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [_vm._v("\n      Profile Picture\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_c('div', {
    staticClass: "ui text container"
  }, [_c('p', [_vm._v("We'll send you an email to reset your password.")]), _vm._v(" "), _c('div', {
    staticClass: "ui input right aligned"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Email Address"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "toc item"
  }, [_c('i', {
    staticClass: "sidebar icon"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "ui image header"
  }, [_c('i', {
    staticClass: "flag us"
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n            Log in to your account\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "actions"
  }, [_c('div', {
    staticClass: "ui black deny button"
  }, [_vm._v("\n        Nope\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "ui positive right labeled icon button"
  }, [_vm._v("\n        Yep, that's me\n        "), _c('i', {
    staticClass: "checkmark icon"
  })])])
}]}

/***/ }),

/***/ 102:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pusher"
  }, [_c('div', {
    staticClass: "ui inverted vertical center aligned segment"
  }, [_c('div', {
    staticClass: "ui container"
  }, [_c('div', {
    staticClass: "ui large secondary inverted pointing menu"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "right item"
  }, [_c('a', {
    staticClass: "ui inverted button",
    on: {
      "~click": function($event) {
        return _vm.logout($event)
      }
    }
  }, [_vm._v("Log Out")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "ui container basic segment"
  }, [_c('div', {
    staticClass: "ui tab active",
    attrs: {
      "data-tab": "data"
    }
  }, [_c('h4', {
    staticClass: "ui header"
  }, [_c('i', {
    staticClass: "download icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n            Download\n            "), _c('div', {
    staticClass: "ui inline dropdown"
  }, [_c('div', {
    staticClass: "text",
    model: {
      value: (_vm.dataQuery_dateRange),
      callback: function($$v) {
        _vm.dataQuery_dateRange = $$v
      },
      expression: "dataQuery_dateRange"
    }
  }, [_vm._v(_vm._s(_vm.dataQuery_dateRange))]), _vm._v(" "), _c('i', {
    staticClass: "dropdown icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "menu"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("Adjust time span")]), _vm._v(" "), _c('div', {
    staticClass: "active item",
    attrs: {
      "data-text": "latest"
    },
    on: {
      "click": function($event) {
        _vm.dataQuery_dateRange = '1'
      }
    }
  }, [_vm._v("Latest")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-text": "1 month"
    },
    on: {
      "click": function($event) {
        _vm.dataQuery_dateRange = '4'
      }
    }
  }, [_vm._v("1 month")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-text": "3 months"
    },
    on: {
      "click": function($event) {
        _vm.dataQuery_dateRange = '12'
      }
    }
  }, [_vm._v("3 months")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-text": "6 months"
    },
    on: {
      "click": function($event) {
        _vm.dataQuery_dateRange = '26'
      }
    }
  }, [_vm._v("6 months")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-text": "12 months"
    },
    on: {
      "click": function($event) {
        _vm.dataQuery_dateRange = '52'
      }
    }
  }, [_vm._v("12 months")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-text": "all"
    },
    on: {
      "click": function($event) {
        _vm.dataQuery_dateRange = '999'
      }
    }
  }, [_vm._v("all")])])]), _vm._v(" "), _c('div', {
    staticClass: "ui inline dropdown"
  }, [_c('div', {
    staticClass: "text",
    model: {
      value: (_vm.dataQuery_dataType),
      callback: function($$v) {
        _vm.dataQuery_dataType = $$v
      },
      expression: "dataQuery_dataType"
    }
  }, [_vm._v(_vm._s(_vm.dataQuery_dataType))]), _vm._v(" "), _c('i', {
    staticClass: "dropdown icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "menu"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("Change the data type")]), _vm._v(" "), _c('div', {
    staticClass: "active item",
    attrs: {
      "data-text": "listings"
    },
    on: {
      "click": function($event) {
        _vm.dataQuery_dataType = 'listings'
      }
    }
  }, [_vm._v("listings")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-text": "rentals"
    },
    on: {
      "click": function($event) {
        _vm.dataQuery_dataType = 'rentals'
      }
    }
  }, [_vm._v("rentals")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-text": "stats"
    },
    on: {
      "click": function($event) {
        _vm.dataQuery_dataType = 'stats'
      }
    }
  }, [_vm._v("stats")])])]), _vm._v("\n\n             data for\n\n            "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dataQuery_counties),
      expression: "dataQuery_counties"
    }],
    staticClass: "ui search dropdown inline",
    class: {
      'hidden': _vm.canSelectCounty
    },
    attrs: {
      "id": "filterCounties",
      "multiple": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.dataQuery_counties = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Location")]), _vm._v(" "), _vm._l((_vm.counties), function(c) {
    return _c('option', {
      domProps: {
        "value": c
      },
      on: {
        "click": function($event) {
          _vm.addCounty(c)
        }
      }
    }, [_vm._v(_vm._s(c))])
  })], 2), _vm._v(" "), _c('small', {
    class: {
      'hidden': !_vm.canSelectCounty || _vm.counties.length < 5
    },
    on: {
      "click": function($event) {
        _vm.allCounties()
      }
    }
  }, [_vm._v("(all)")]), _vm._v(" "), _c('span', {
    class: {
      'hidden': _vm.canSelectCounty
    },
    attrs: {
      "id": "entire-us"
    }
  }, [_vm._v("US")]), _vm._v(" "), _c('div', {
    staticClass: "ui button primary",
    on: {
      "click": function($event) {
        _vm.getList()
      }
    }
  }, [_vm._v("GO")])])]), _vm._v(" "), _c('div', {
    staticClass: "ui hidden divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "ui styled fluid accordion"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "active content"
  }, [_c('div', {
    staticClass: "ui bottom attached segment"
  }, [_c('table', {
    staticClass: "ui celled table"
  }, [_vm._m(3), _vm._v(" "), _vm._l((_vm.list), function(c) {
    return _c('tr', [_c('td', {
      staticClass: "collapsing"
    }, [_vm._v(_vm._s(c.date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(c.county) + " - " + _vm._s(c.state) + " - " + _vm._s(c.type))]), _vm._v(" "), _c('td', {
      staticClass: "collapsing"
    }, [_c('form', {
      attrs: {
        "method": "get",
        "action": _vm.baseDataUrl
      }
    }, [_c('input', {
      attrs: {
        "type": "hidden",
        "name": "county"
      },
      domProps: {
        "value": c.state_county
      }
    }), _vm._v(" "), _c('input', {
      attrs: {
        "type": "hidden",
        "name": "date"
      },
      domProps: {
        "value": c.date
      }
    }), _vm._v(" "), _c('input', {
      attrs: {
        "type": "hidden",
        "name": "type"
      },
      domProps: {
        "value": c.type
      }
    }), _vm._v(" "), _vm._m(4, true)])])])
  })], 2), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.list.length > 0) ? _c('button', {
    staticClass: "ui secondary button",
    on: {
      "click": function($event) {
        _vm.downloadAll()
      }
    }
  }, [_vm._v("\n                Download all\n              ")]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "ui tab",
    attrs: {
      "data-tab": "activity"
    }
  }, [_vm._v("\n        Last activity, downloads and logins etc.\n        "), _c('table', {
    staticClass: "ui celled table"
  }, [_vm._m(5), _vm._v(" "), _vm._l((_vm.activity), function(a) {
    return _c('tr', [_c('td', {
      staticClass: "collapsing"
    }, [_vm._v(_vm._s(a.date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(a.description))]), _vm._v(" "), _c('td', {
      staticClass: "collapsing"
    }, [_vm._v(_vm._s(a.who))])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "ui tab",
    attrs: {
      "data-tab": "settings"
    }
  }, [_c('div', {
    staticClass: "ui cards"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v(_vm._s(_vm.user.name))]), _vm._v(" "), _c('div', {
    staticClass: "meta"
  }, [_vm._v("\n                " + _vm._s(_vm.user.email) + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_c('div', {
    staticClass: "ui small feed"
  }, [_c('div', {
    staticClass: "content"
  }, [_vm._v("\n                    " + _vm._s(_vm.user.phone) + "\n                  ")])]), _vm._v(" "), _vm._m(6)])])]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("Subscription:")]), _vm._v(" "), _c('div', {
    staticClass: "meta"
  }, [_c('i', {
    staticClass: "flag us"
  }), _vm._v("\n\n                " + _vm._s(_vm.user.plan) + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_c('div', {
    staticClass: "ui small feed"
  }, [_c('div', {
    staticClass: "content"
  }, [(!_vm.countyPlan) ? _c('div', [_vm._v("3000 counties across the US")]) : _vm._e()])])]), _vm._v(" "), (_vm.countyPlan) ? _c('h4', {
    staticClass: "ui sub header"
  }, [_vm._v("Counties")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.counties), function(c) {
    return (_vm.countyPlan) ? _c('div', {
      staticClass: "ui small feed"
    }, [_c('div', {
      staticClass: "county"
    }, [_c('div', {
      staticClass: "content"
    }, [_c('div', {
      staticClass: "summary"
    }, [_vm._v("\n                       " + _vm._s(c) + "\n                    ")])])])]) : _vm._e()
  })], 2), _vm._v(" "), (_vm.countyPlan) ? _c('div', {
    staticClass: "ui bottom attached button"
  }, [_c('i', {
    staticClass: "add icon"
  }), _vm._v("\n              Add County\n            ")]) : _vm._e()])]), _vm._v(" "), (_vm.bills.length > 0) ? _c('h2', [_vm._v("Billing History")]) : _vm._e(), _vm._v(" "), (_vm.bills.length > 0) ? _c('table', {
    staticClass: "ui celled table"
  }, [_vm._m(8), _vm._v(" "), _vm._l((_vm.bills), function(b) {
    return _c('tr', {
      class: {
        'positive': b.paid, 'negative': !b.paid
      }
    }, [_c('td', [_vm._v(_vm._s(b.date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(b.amount))]), _vm._v(" "), _c('td', {
      staticClass: "collapsing"
    }, [_c('i', {
      staticClass: "icon",
      class: {
        'checkmark': b.paid, 'close': !b.paid
      }
    })]), _vm._v(" "), _vm._m(9, true)])
  })], 2) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(10)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "toc item"
  }, [_c('i', {
    staticClass: "sidebar icon"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui inverted secondary pointing menu tabs"
  }, [_c('a', {
    staticClass: "item active",
    attrs: {
      "data-tab": "data"
    }
  }, [_vm._v("\n              Data\n            ")]), _vm._v(" "), _c('a', {
    staticClass: "item",
    attrs: {
      "data-tab": "activity"
    }
  }, [_vm._v("\n              Activity\n            ")]), _vm._v(" "), _c('a', {
    staticClass: "item",
    attrs: {
      "data-tab": "settings"
    }
  }, [_vm._v("\n              Settings\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "active title"
  }, [_c('i', {
    staticClass: "dropdown icon"
  }), _vm._v("\n            via browser\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "collapsing"
  }, [_vm._v("Date")]), _vm._v(" "), _c('th', [_vm._v("Location")]), _vm._v(" "), _c('th', {
    staticClass: "collapsing"
  }, [_vm._v("Download")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "ui button"
  }, [_c('i', {
    staticClass: "download icon"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "collapsing"
  }, [_vm._v("Date")]), _vm._v(" "), _c('th', [_vm._v("Description")]), _vm._v(" "), _c('th', {
    staticClass: "collapsing"
  }, [_vm._v("Who")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "ui basic mini button"
  }, [_c('i', {
    staticClass: "lock icon"
  }), _vm._v("\n                  Change Password\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("Credit Card")]), _vm._v(" "), _c('div', {
    staticClass: "meta"
  }, [_vm._v("(Stored in Stripe)")]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_c('div', {
    staticClass: "ui small feed"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "credit-card"
  }, [_vm._v("\n                      --\n                    ")])])]), _vm._v(" "), _c('button', {
    staticClass: "ui basic mini button"
  }, [_c('i', {
    staticClass: "credit card alternative icon"
  }), _vm._v("\n                  Update Card\n                ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Due Date")]), _vm._v(" "), _c('th', [_vm._v("Amount")]), _vm._v(" "), _c('th', {
    staticClass: "collapsing"
  }, [_vm._v("Paid")]), _vm._v(" "), _c('th', {
    staticClass: "collapsing"
  }, [_vm._v("Invoice")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "collapsing"
  }, [_c('button', {
    staticClass: "ui button primary"
  }, [_c('i', {
    staticClass: "file text outline icon"
  }), _vm._v("\n                Invoice\n              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_vm._v("\n          Contact us: "), _c('a', {
    attrs: {
      "href": "mailto:support@altosresearch.com"
    }
  }, [_vm._v("support@altosresearch.com")])])
}]}

/***/ }),

/***/ 38:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hello__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hello___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Hello__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Signup__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Signup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Signup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Login__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Dashboard__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Dashboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Dashboard__);







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var NotFound = { template: '<p>Page not found</p>' };

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Hello',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Hello___default.a
  }, {
    path: '/signup',
    name: 'Signup',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Signup___default.a
  }, {
    path: '/pricing',
    name: 'Pricing',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Signup___default.a
  }, {
    path: '/login',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Login___default.a
  }, {
    path: '/dashboard',
    name: 'Dashboard',
    component: __WEBPACK_IMPORTED_MODULE_5__components_Dashboard___default.a
  }, {
    path: '*',
    component: NotFound }],
  mode: 'history'
}));

/***/ }),

/***/ 39:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(84)
}
var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(41),
  /* template */
  __webpack_require__(98),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 40:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(38);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),

/***/ 41:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),

/***/ 42:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(5);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var $ = window.$; // perhaps require('jQuery') would be better?
var hljs = window.hljs;
 // Note: is there a new require syntax for this?

$.ajaxSetup({ xhrFields: { withCredentials: true } });

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'signup',
  data: function data() {
    return {
      msg: 'Welcome to List page',
      baseDataUrl: 'https://data.altos.re/api/data?',
      dataQuery_counties: [],
      dataQuery_dateRange: 'latest',
      dataQuery_dataType: 'listings',
      settings: { 'user': {} },
      activity: [],
      bills: [],
      list: [],
      pythonCode: '#!/bin/bash python\nfor file_name in ["a", "b"]:\n    print(file_name)'
    };
  },

  computed: {
    counties: function counties() {
      var user = this.settings.user;
      return user.counties ? user.counties.split(',') : [];
    },
    user: function user() {
      var that = this;
      var user = this.settings.user;
      console.log('here');
      if (user && user.countyPlan) {
        that.$forceUpdate();
        that.setAllUS(false);
        __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick(function () {
          that.dataQuery_counties = that.user.counties.split(',').map(function (s) {
            // $('#filterCounties').dropdown('set selected', s)
            return s;
          });
          that.$forceUpdate();
        });
      }
      return user;
    },
    allUsOrCounties: function allUsOrCounties() {
      return this.dataQuery_allUS ? 'all of the us' : this.isDemo ? 'demo' : 'counties';
    },
    isDemo: function isDemo() {
      return this.user.plan === 'demo';
    },
    canSelectCounty: function canSelectCounty() {
      this.$forceUpdate();
      // console.log('canSelectCounty')
      // console.log(!this.dataQuery_allUS && !this.isDemo)
      return !this.dataQuery_allUS && !this.isDemo;
    },
    apiKey: function apiKey() {
      console.log(this.user);
      return this.user['api_key'];
    },
    dataQuery_allUS: function dataQuery_allUS() {
      console.log('plan', this.user.plan);
      var usAll = this.user.plan === 'us-all';
      if (usAll) {
        this.setAllUS(usAll);
      }
      return usAll;
    },
    csvFiles: function csvFiles() {
      var that = this;
      if (that.dataQuery_allUS) {
        return [{ 'county': 'us-all', 'date': '2006-01-01' }];
      } else {
        return [].concat.apply([], that.dataQuery_counties.map(function (c) {
          that.getList(c);
        }));
      }
    },
    countyPlan: function countyPlan() {
      return this.user.plan && this.user.plan !== 'us-all';
    }
  },
  methods: {
    // https://stackoverflow.com/a/24782004/1240268
    chunk: function chunk(arr, chunkSize) {
      var R = [];
      for (var i = 0, len = arr.length; i < len; i += chunkSize) {
        R.push(arr.slice(i, i + chunkSize));
      }
      return R;
    },
    fridaysFromDate: function fridaysFromDate(date) {
      console.log(d);
      var d = new Date(date);
      console.log(date);
      var until = new Date('2017-09-20');
      var result = [];
      // aim is to get array of dates from then 'til now
      while (d < until) {
        d = new Date(d);d.setDate(d.getDate() + 7);result.push(d);
      }
      console.log(result);
      return result;
    },
    setAllUS: function setAllUS(flag) {
      var that = this;
      this.dataQuery_allUS = flag;

      that.$forceUpdate();
      __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick(function () {
        if (that.dataQuery_allUS) {
          // whelp
          $('div:has(> #filterCounties)').hide();
          $('#entire-us').show();
        } else {
          $('div:has(> #filterCounties)').show();
          $('#filterCounties.ui.dropdown').dropdown();
          $('#entire-us').hide();
        }
        that.$forceUpdate();
      });
    },
    allCounties: function allCounties() {
      this.counties.map(function (s) {
        $('#filterCounties').dropdown('set selected', s);
      });
      this.$forceUpdate();
    },
    logout: function logout() {
      document.cookie = 'vx_session=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
      this.$router.replace({ name: 'Login' });
    },
    printData: function printData() {
      console.log(this);
    },
    download: function download(c) {
      console.log('Downloading', c);
    },
    addCounty: function addCounty(c) {
      console.log('Adding county', c);
    },
    downloadAll: function downloadAll() {
      /**
       * Download a list of files.
       * @author speedplane
       * https://stackoverflow.com/a/29606450/1240268
       * (modified to download csvFiles)
       */
      console.log('oi');
      var that = this;
      function downloadNext(i) {
        if (i >= that.list.length) {
          return;
        }
        var a = document.createElement('a');
        a.href = that.dataUrl(that.list[i]);
        a.target = '_parent';
        // Use a.download if available, it prevents plugins from opening.
        if ('download' in a) {
          // regex .replace(/^.*[\\\/]/, '') gets the filename
          // TODO use cleaner name? e.g. via function
          a.download = a.href.replace(/^.*[\\/]/, '');
        }
        // Add a to the doc for click to work.
        (document.body || document.documentElement).appendChild(a);
        if (a.click) {
          a.click(); // The click method is supported by most browsers.
        } else {
          $(a).click(); // Backup using jquery
        }
        // Delete the temporary link.
        a.parentNode.removeChild(a);
        // Download the next file with a small timeout. The timeout is necessary
        // for IE, which will otherwise only download the first file.
        setTimeout(function () {
          downloadNext(i + 1);
        }, 500);
      }
      // Initiate the first download.
      downloadNext(0);
    },
    dataUrl: function dataUrl(c) {
      var url = this.baseDataUrl + 'county=' + c.state_county + '&date=' + c.date + '&type=' + c.type;
      console.log(url);
      return url;
    },
    getSettings: function getSettings() {
      var that = this;
      return $.get('https://data.altos.re/api/settings').then(function (s) {
        that.settings = s;
        that.dataQuery_dataType = that.settings.user.types.split(',')[0];
        that.$forceUpdate();
      }, function () {
        that.logout();console.log('error');
      });
    },
    getActivity: function getActivity() {
      var that = this;
      $.get('https://data.altos.re/api/activity').then(function (a) {
        a.map(function (e) {
          e.who = e['user-agent'].slice(0, 7);
          e.date = new Date(e['ts'] * 1000).toLocaleString();
          e.description = 'Access ' + e['path'];
        });
        that.activity = a;
      }, function () {
        console.log('error');
      });
    },
    getList: function getList(county) {
      this.$forceUpdate();

      // optionall pass county?
      var that = this;
      var qs = '?type=' + that.dataQuery_dataType + '&range=' + this.dataQuery_dateRange;
      that.list = [];
      console.log('xxxx');

      // FIXME use a this var for this
      var selectedCounties = $('#filterCounties').parent().children('a').toArray().map(function (e) {
        return e.dataset.value;
      });

      if (this.canSelectCounty) {
        if (selectedCounties.length > 0) {
          var countyChunked = this.chunk(selectedCounties, 5);
          for (var i = 0; i < countyChunked.length; i++) {
            var qsc = '&county=' + countyChunked[i].join(',');
            console.log('https://data.altos.re/api/list' + qs + qsc);
            $.get('https://data.altos.re/api/list' + qs + qsc).then(function (a) {
              that.list = that.list.concat(a);
            }, function () {
              console.log('error');
            });
          }
        }
      } else {
        console.log('yyyy');
        $.get('https://data.altos.re/api/list' + qs).then(function (a) {
          that.list = that.list.concat(a);
        }, function () {
          console.log('error');
        });
      }
      that.$forceUpdate();
    }
  },
  mounted: function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              $('.ui.sidebar').sidebar('attach events', '.toc.item');

              $('.ui.dropdown').dropdown();

              // should be done each change (tab)?
              // $('#county-select.ui.dropdown')
              //  .dropdown({message: {noResults: 'No results found.'}})

              $('.tabs.menu .item').tab();

              $('.ui.accordion').accordion();

              $('pre code').each(function (i, block) {
                hljs.highlightBlock(block);
              });

              _context.next = 7;
              return this.getSettings();

            case 7:
              this.getActivity();
              this.setAllUS(!this.canSelectCounty);
              if (this.counties.length === 1) {
                this.allCounties();
              }
              this.getList();

              // verify that the user is signed in!

            case 11:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function mounted() {
      return _ref.apply(this, arguments);
    }

    return mounted;
  }()
});

/***/ }),

/***/ 43:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var $ = window.$;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'hello',
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js App'
    };
  },

  mounted: function mounted() {
    $('.ui.sidebar').sidebar('attach events', '.toc.item');
  }
});

/***/ }),

/***/ 44:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var $ = window.$; // perhaps require('jQuery') would be better?
 // Note: is there a new require syntax for this?

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'signup',
  data: function data() {
    return {
      email: '',
      password: '',

      errorMessage: ''
    };
  },

  computed: {
    filledIn: function filledIn() {
      return !!this.email && !!this.password;
    }
  },
  methods: {
    login: function login() {
      // TODO move the Login
      $('#login.ui.form').form({
        fields: {
          email: {
            identifier: 'email',
            rules: [{
              type: 'email',
              prompt: 'Please enter a valid email address'
            }]
          },
          password: {
            identifier: 'password',
            rules: [{
              type: 'empty',
              prompt: 'Please enter a password'
            }, {
              type: 'minLength[10]',
              prompt: 'Your password is at least {ruleValue} characters'
            }]
          }
        }
      }, { onSuccess: this.go() });
    },
    forgotPasswordModal: function forgotPasswordModal() {
      __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].nextTick(function () {
        $('.ui.modal').modal('show');
      });
    },
    go: function go(event, fields) {
      var that = this;
      __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].nextTick(function () {
        if ($('#login.ui.form').form('validate form')) {
          console.log('SUBMIT');
          console.log(that.email);
          console.log(that.password);

          $.post({
            url: 'https://data.altos.re/api/login',
            data: {
              email: that.email,
              password: that.password
            },
            success: function success(response) {
              console.log(response);
              console.log('success');
              that.$router.push({ name: 'Dashboard' });
            },
            error: function error(_error) {
              console.log(_error);
              that.errorMessage = _error.responseJSON.error;
              that.password = '';
            }
          });
          // TODO post to /api/login and handle errors
        }
      });
    }
  },
  mounted: function mounted() {
    $('.ui.sidebar').sidebar('attach events', '.toc.item');
  }
});

/***/ }),

/***/ 45:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var $ = window.$; // require('jQuery') would be better?
var Stripe = window.Stripe;


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'signup',
  data: function data() {
    return {
      plan: 'us-all',
      counties: [],
      name: '',
      email: '',
      password: '',
      phone: '',
      stripeToken: '',
      terms: false,
      stripeZipFilled: false,

      submitted: false,
      errorMessage: ''
    };
  },

  computed: {
    countyPlan: function countyPlan() {
      return this.plan === 'county';
    },
    filledIn: function filledIn() {
      // console.log(this)
      return !!this.plan && !!this.name && !!this.email && !!this.password && !!this.setZipFilled && this.terms;
    }
  },
  methods: {
    doThis: function doThis(event, callback) {
      console.log('hi');
      console.log(this);
      this.$once('click', this.foo);
    },
    foo: function foo() {
      console.log('foo');
    },
    emailComplete: function emailComplete() {},
    setZipFilled: function setZipFilled(postalCode) {
      // NOTE is better way to see card is filled in?
      this.stripeZipFilled = String(postalCode).length === 5;
    },
    stripeSubmit: function stripeSubmit() {},
    create: function create(token) {
      var that = this;
      // NOTE: this is a workaround for only submitting the form once
      // most likely it would be better to enforce once only clicking...
      var otherSubmitInProgress = this.submitted;
      this.submitted = true;
      this.$forceUpdate();
      __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].nextTick(function () {
        var validatedForm = $('#payment-form.ui.form').form('validate form');
        if (that.filledIn && !otherSubmitInProgress && validatedForm) {
          console.log('SUBMIT');
          console.log(that.email);
          console.log(token);

          $.post({
            url: '/api/signup',
            data: {
              plan: that.plan,
              counties: that.counties.toString(),
              email: that.email,
              password: that.password,
              phone: that.phone,
              stripeToken: token.id
            },
            success: function success(response) {
              console.log('success');
              that.$router.push({ name: 'Dashboard' });
            },
            error: function error(_error) {
              console.log(_error);
              that.errorMessage = _error.responseJSON.error;
              that.submitted = false; // TODO setTimeout here?

              // if it's credit card we should... do someething abuot it? focus or something?
            }
          });
        }
        if (!validatedForm) {
          console.log('invalid form');
          that.submitted = false;
        }
      });
    },
    submitClick: function submitClick(event) {
      var that = this;

      if (this.submitInProgress) {
        console.log('submit');
        this.timer = setTimeout(function () {
          that.submitInProgress = false;
        }, 700);
      } else {
        clearTimeout(that.timer);
        console.log('double click');
        that.submitInProgress = true;
      }
    }
  },
  mounted: function mounted() {
    var that = this;

    $('.ui.sidebar').sidebar('attach events', '.toc.item');

    $('.ui.dropdown').dropdown();

    $('#county-select.ui.dropdown').dropdown({ message: { noResults: 'No results found.' } });

    $('#payment-form.ui.form').form({
      fields: {
        name: {
          identifier: 'name',
          rules: [{
            type: 'empty',
            prompt: 'Please enter your name'
          }]
        },
        email: {
          identifier: 'email',
          rules: [{
            type: 'email',
            prompt: 'Please enter a valid email address'
          }]
        },
        password: {
          identifier: 'password',
          rules: [{
            type: 'empty',
            prompt: 'Please enter a password'
          }, {
            type: 'minLength[10]',
            prompt: 'Your password must be at least {ruleValue} characters'
          }]
        },
        terms: {
          identifier: 'terms',
          rules: [{
            type: 'checked',
            prompt: 'You must agree to the terms and conditions'
          }]
        }
      }
    });

    // Create a Stripe client
    this._stripe = Stripe('pk_test_tPwSUvCAeBdKG6VGlpMbsdBa');

    // Create an instance of Elements
    var elements = this._stripe.elements();

    // Custom styling can be passed to options when creating an Element.
    // (Note that this demo uses a wider set of styles than the guide below.)
    var style = {
      base: {
        color: '#32325d',
        lineHeight: '24px',
        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
        fontSmoothing: 'antialiased',
        fontSize: '16px',
        '::placeholder': {
          color: '#aab7c4'
        }
      },
      invalid: {
        color: '#fa755a',
        iconColor: '#fa755a'
      }
      // Create an instance of the card Element
    };this.card = elements.create('card', { style: style });

    // Add an instance of the card Element into the `card-element` <div>
    this.card.mount('#card-element');

    // Handle real-time validation errors from the card Element.
    this.card.addEventListener('change', function (event) {
      var displayError = document.getElementById('card-errors');
      if (event.error) {
        displayError.textContent = event.error.message;
      } else {
        displayError.textContent = '';
      }
    });

    // Handle form submission
    var form = document.getElementById('payment-form');
    form && form.addEventListener('submit', function (event) {
      event.preventDefault();

      that._stripe.createToken(that.card).then(function (result) {
        if (result.error) {
          // Inform the user if there was an error
          var errorElement = document.getElementById('card-errors');
          errorElement.textContent = result.error.message;
        } else {
          // FIXME would like to move this into Vue
          // but atm doing so with @click submits multiple times!

          // Send the token to your server
          that.create(result.token);
        }
      });
    });

    that.card.addEventListener('change', function (event) {
      if (event.value.postalCode) {
        that.setZipFilled(event.value.postalCode);
      }
      var displayError = document.getElementById('card-errors');
      if (event.error) {
        displayError.textContent = event.error.message;
      } else {
        displayError.textContent = '';
      }
    });
  }
});

/***/ }),

/***/ 84:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 85:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 86:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 87:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 88:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 94:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(88)
}
var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(42),
  /* template */
  __webpack_require__(102),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f1aad108",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 95:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(85)
}
var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(43),
  /* template */
  __webpack_require__(99),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-162a1eba",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 96:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(87)
}
var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(44),
  /* template */
  __webpack_require__(101),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-685bd1d1",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 97:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(86)
}
var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(45),
  /* template */
  __webpack_require__(100),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-210f5540",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 98:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-view')
},staticRenderFns: []}

/***/ }),

/***/ 99:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pusher"
  }, [_c('div', {
    staticClass: "ui inverted vertical masthead center aligned segment",
    attrs: {
      "id": "home-section"
    }
  }, [_c('div', {
    staticClass: "ui container"
  }, [_c('div', {
    staticClass: "ui large secondary inverted pointing menu"
  }, [_vm._m(0), _vm._v(" "), _c('router-link', {
    staticClass: "item",
    attrs: {
      "to": {
        name: 'Hello'
      }
    }
  }, [_vm._v("About")]), _vm._v(" "), _c('router-link', {
    staticClass: "item",
    attrs: {
      "to": {
        name: 'Pricing'
      }
    }
  }, [_vm._v("Pricing")]), _vm._v(" "), _c('div', {
    staticClass: "right item"
  }, [_c('router-link', {
    staticClass: "ui inverted button",
    attrs: {
      "to": {
        name: 'Login'
      }
    }
  }, [_vm._v("Login In")]), _vm._v(" "), _c('router-link', {
    staticClass: "ui inverted button",
    attrs: {
      "to": {
        name: 'Signup'
      }
    }
  }, [_vm._v("Sign Up")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "ui text container"
  }, [_c('h1', {
    staticClass: "ui inverted header"
  }, [_vm._v("\n        VX Data\n      ")]), _vm._v(" "), _c('h2', [_vm._v("Latest real estate market data")]), _vm._v(" "), _c('router-link', {
    staticClass: "ui huge primary button",
    attrs: {
      "to": {
        name: 'Signup'
      }
    }
  }, [_vm._v("Get Started "), _c('i', {
    staticClass: "right arrow icon"
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "ui vertical stripe segment",
    attrs: {
      "id": "data-section"
    }
  }, [_c('div', {
    staticClass: "ui middle aligned stackable grid container"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "center aligned column"
  }, [_c('router-link', {
    staticClass: "ui huge primary butto",
    attrs: {
      "to": {
        name: 'Signup'
      }
    }
  }, [_vm._v("Sign Up")])], 1)])])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "toc item"
  }, [_c('i', {
    staticClass: "sidebar icon"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "eight wide column"
  }, [_c('h3', {
    staticClass: "ui header"
  }, [_vm._v("Latest market data available each week")]), _vm._v(" "), _c('p', [_vm._v("Every week we take a snapshot of the housing market across the entire US.")]), _vm._v(" "), _c('h3', {
    staticClass: "ui header"
  }, [_vm._v("Simple data format")]), _vm._v(" "), _c('p', [_vm._v("Plain old CSV, already clean, easy to load into your pipeline. (See example CSV.)")]), _vm._v(" "), _c('h3', {
    staticClass: "ui header"
  }, [_vm._v("Historical data, going back ten years*")]), _vm._v(" "), _c('p', [_vm._v("We've been doing this a while. With all plans, you'll get the last 12 months of market data.")]), _vm._v(" "), _c('small', [_vm._v("*historical data is available at additional cost.")])]), _vm._v(" "), _c('div', {
    staticClass: "six wide right floated column"
  }, [_c('img', {
    staticClass: "ui large bordered rounded image",
    attrs: {
      "src": "static/anna-goncharova-73258.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui vertical stripe quote segment"
  }, [_c('div', {
    staticClass: "ui equal width stackable internally celled grid"
  }, [_c('div', {
    staticClass: "center aligned row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('h3', [_vm._v("\"Up and running in minutes\"")]), _vm._v(" "), _c('p', [_vm._v("That is what they all say about us")])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h3', [_vm._v("\"No munging required.\"")]), _vm._v(" "), _c('p', [_c('img', {
    staticClass: "ui avatar image",
    attrs: {
      "src": "assets/images/avatar/nan.jpg"
    }
  }), _vm._v(" "), _c('b', [_vm._v("Sheila")]), _vm._v(" Chief Data Scientist Acme Toys\n          ")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui vertical stripe segment"
  }, [_c('div', {
    staticClass: "ui text container"
  }, [_c('h3', {
    staticClass: "ui header"
  }, [_vm._v("Breaking The Grid, Grabs Your Attention")]), _vm._v(" "), _c('p', [_vm._v("Instead of focusing on content creation and hard work, we have learned how to master the art of doing nothing by providing massive amounts of whitespace and generic content that can seem massive, monolithic and worth your attention.")]), _vm._v(" "), _c('a', {
    staticClass: "ui large button"
  }, [_vm._v("Read More")]), _vm._v(" "), _c('h4', {
    staticClass: "ui horizontal header divider"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Case Studies")])]), _vm._v(" "), _c('h3', {
    staticClass: "ui header"
  }, [_vm._v("Did We Tell You About Our Bananas?")]), _vm._v(" "), _c('p', [_vm._v("Yes I know you probably disregarded the earlier boasts as non-sequitur filler content, but its really true. It took years of gene splicing and combinatory DNA research, but our bananas can really dance.")]), _vm._v(" "), _c('a', {
    staticClass: "ui large button"
  }, [_vm._v("I'm Still Quite Interested")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui inverted vertical footer segment"
  }, [_c('div', {
    staticClass: "ui container"
  }, [_c('div', {
    staticClass: "ui stackable inverted divided equal height stackable grid"
  }, [_c('div', {
    staticClass: "three wide column"
  }, [_c('h4', {
    staticClass: "ui inverted header"
  }, [_vm._v("About")]), _vm._v(" "), _c('div', {
    staticClass: "ui inverted link list"
  }, [_c('a', {
    staticClass: "item",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Sitemap")]), _vm._v(" "), _c('a', {
    staticClass: "item",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Contact Us")]), _vm._v(" "), _c('a', {
    staticClass: "item",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Religious Ceremonies")]), _vm._v(" "), _c('a', {
    staticClass: "item",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Gazebo Plans")])])]), _vm._v(" "), _c('div', {
    staticClass: "three wide column"
  }, [_c('h4', {
    staticClass: "ui inverted header"
  }, [_vm._v("Services")]), _vm._v(" "), _c('div', {
    staticClass: "ui inverted link list"
  }, [_c('a', {
    staticClass: "item",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Banana Pre-Order")]), _vm._v(" "), _c('a', {
    staticClass: "item",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("DNA FAQ")]), _vm._v(" "), _c('a', {
    staticClass: "item",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("How To Access")]), _vm._v(" "), _c('a', {
    staticClass: "item",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Favorite X-Men")])])]), _vm._v(" "), _c('div', {
    staticClass: "seven wide column"
  }, [_c('h4', {
    staticClass: "ui inverted header"
  }, [_vm._v("Footer Header")]), _vm._v(" "), _c('p', [_vm._v("Extra space for a call to action inside the footer that could help re-engage users.")])])])])])
}]}

/***/ })

},[40]);


// WEBPACK FOOTER //
// static/js/app.e922b0d292073fb187f6.js